export var DEFAULT_LOCATION_AVAILABLE = "Y";
export var LOCATION_INCLUDED_KEY;
(function (LOCATION_INCLUDED_KEY) {
    LOCATION_INCLUDED_KEY["LOCATION_UNITS"] = "location_units";
})(LOCATION_INCLUDED_KEY || (LOCATION_INCLUDED_KEY = {}));
